import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../axiosInstance";

export interface LastPerformed {
  date: string | null;
  formatted_date: string | null;
  concert_id: number | null;
  concert_name: string | null;
  status: string | null;
  days_ago: number | null;
  total_times_performed: number;
}

export interface Track {
  id: number;
  name: string;
  youtube_url: string | null;
  image: string | null;
  artist: string;
  play_order: number;
  last_performed: LastPerformed | null;
}

export interface Album {
  id: number;
  name: string;
  cover: string;
  release_date: string;
  tracks: Track[];
}

export const getAlbumList = async (lang: string = "ko"): Promise<Album[]> => {
  const response = await axiosInstance.get("/api/v1/musics/albums", {
    params: { lang },
  });
  return response.data;
};

export const useAlbumList = (lang: string = "ko") => {
  return useQuery<Album[]>({
    queryKey: ["AlbumList", lang],
    queryFn: () => getAlbumList(lang),
  });
};

export const getMusicList = async (lang: string = "ko", search: string = ""): Promise<Track[]> => {
  const response = await axiosInstance.get("/api/v1/musics", {
    params: { lang, search },
  });
  return response.data;
};

export const useMusicList = (lang: string = "ko", search: string = "") => {
  return useQuery<Track[]>({
    queryKey: ["MusicList", lang, search],
    queryFn: () => getMusicList(lang, search),
  });
};
